var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoSearchResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.667c5.983 0 10.833 4.85 10.833 10.833 0 2.369-.76 4.56-2.05 6.343l6.225 5.475a2.262 2.262 0 11-3.189 3.189l-5.478-6.222a10.785 10.785 0 01-6.341 2.048c-5.983 0-10.833-4.85-10.833-10.833 0-5.983 4.85-10.833 10.833-10.833zm0 2.916a7.917 7.917 0 100 15.834 7.917 7.917 0 000-15.834zm-.12 11.52a1.31 1.31 0 11-1.297 1.487l-.012-.177c0-.663.493-1.211 1.132-1.298l.178-.012zm.001-9.603c1.929 0 3.492 1.368 3.492 3.056 0 1.2-.461 1.866-.988 2.401l-.357.342-.35.33c-.394.387-.723.805-.798 1.441l-.017.287a.437.437 0 01-.436.437h-.983a.437.437 0 01-.425-.337l-.011-.1c0-1.318.507-1.98 1.06-2.516l.499-.46c.485-.456.896-.936.896-1.825 0-.724-.82-1.31-1.664-1.31-.779 0-1.55.5-1.663 1.145l-.015.165c-.002.165.015.33.049.492l.065.239a.435.435 0 01-.41.578h-.887a.438.438 0 01-.378-.214l-.045-.106a3.654 3.654 0 01-.126-.99c0-1.687 1.563-3.055 3.492-3.055z",
    fill: "#9BADBC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default ForwardRef;